<template>
  <v-breadcrumbs :items="items" />
</template>

<script>
export default {
  name: 'TheBreadCrumbs',
  props: {
    items: {
      type: Array,
    },
  },
};
</script>
